import { menuListItems } from "assets/menu/menuList";
import { BreadCrumb } from "components/BreadCrumb";
import { GoToBack } from "components/GoToBack";
import { Header } from "components/Header";
import { Menu } from "components/Menu";
import React from "react";
import { useParams } from "react-router-dom";
import { RegistrationForm } from "../RegistrationForm";
import { HeaderContainer } from "./styles";
import { useRegistrationEdit } from "./useRegistrationEdit";

export const RegistrationEdit: React.FC = () => {
  const { eventId, registrationId } = useParams<{
    eventId: string;
    registrationId: string;
  }>();

  const {
    handleChange,
    inputsValues,
    touched,
    errors,
    handleSubmit,
    isLoading,
    hasError,
    customerId,
    handlePhotoUploaded,
    handlePhotoRemoved,
    handleSubmitWithPhoto,
  } = useRegistrationEdit(eventId!, registrationId!);

  return (
    <Menu links={menuListItems}>
      <Header>
        <HeaderContainer>
          <div>
            <GoToBack />
          </div>

          <div className="header-text">
            <BreadCrumb
              itens={["Eventos", "Detalhes", "Editar Inscrição"]}
              itemActive="Editar Inscrição"
            />
          </div>
        </HeaderContainer>
      </Header>

      <RegistrationForm
        handleChange={handleChange}
        inputsValues={inputsValues}
        touched={touched}
        errors={errors}
        handleSubmit={handleSubmit}
        isLoading={isLoading}
        hasError={hasError}
        isEditing={true}
        eventId={eventId}
        registrationId={registrationId}
        customerId={customerId}
        onPhotoUploaded={handlePhotoUploaded}
        onPhotoRemoved={handlePhotoRemoved}
        onSubmitWithPhoto={handleSubmitWithPhoto}
      />
    </Menu>
  );
};
